import { getWindowObject } from '@eventbrite/feature-detection';
import { ISplitState } from '@splitsoftware/splitio-redux/lib/types';
import { SPLIT_IO_API_KEYS } from '../constants';

const getSplitioKey = (prodKey: string | null) => {
    if (prodKey) {
        return prodKey;
    }
    const { hostname } = getWindowObject('location') || {};
    return hostname?.includes('dev')
        ? SPLIT_IO_API_KEYS.dev
        : SPLIT_IO_API_KEYS.evbqa;
};

export const getSplitioClient = (eventId: string, prodKey: string | null) => ({
    core: {
        authorizationKey: getSplitioKey(prodKey),
        key: eventId, // Unique id to track anonymous users
    },
    startup: {
        readyTimeout: 1.5,
    },
});

export const createMockSplitState: (flags: any) => ISplitState = (
    flags: any,
) => {
    const treatments: any = Object.fromEntries(
        Object.keys(flags).map((key) => [
            key,
            { 1: { treatment: flags[key] } },
        ]),
    );
    return {
        isReady: true,
        isReadyFromCache: true,
        isTimedout: true,
        hasTimedout: true,
        isDestroyed: true,
        lastUpdate: -1,
        treatments,
    };
};

/* Split IO keys */
export const ENABLE_INTERSTITIAL_STEP =
    'login_as_interstitial_step_in_checkout';

export const ENABLE_APPLE_PAY = 'checkout_enable_apple_pay';

export const ENABLE_NOS_DEMO = 'checkout_enable_nos_demo';
export const ENABLE_NOS_INTEGRATION = 'checkout_enable_nos_integration';

export const ENABLE_GOOGLE_PAY = 'checkout_enable_google_pay';
